import { BankAccountValidationErrorJson } from './types';
import { DefaultError } from 'errors/DefaultError';

type CustomError = Error & {
  errorMsg?: string;
};
export class ResidentialSupplyAddress422Error extends DefaultError<BankAccountValidationErrorJson> {
  messageForAgent: string;

  constructor(error: CustomError) {
    super({
      error: new Error(JSON.stringify(error)),
      name: ResidentialSupplyAddress422Error.name,
      title: 'Sorry, there is a problem with your bank details',
      message: `Please check the details you have entered are correct and try again. 
                This includes the address where your bank accounts are currently 
                registered.`
    });
    this.messageForAgent = error.errorMsg ? error.errorMsg : ' ';
  }

  static get name() {
    return 'ResidentialSupplyAddress422Error';
  }
}

export class ResidentialNonSupplyAddress422Error extends DefaultError<BankAccountValidationErrorJson> {
  messageForAgent: string;

  constructor(error: CustomError) {
    super({
      error: new Error(JSON.stringify(error)),
      name: ResidentialNonSupplyAddress422Error.name,
      title: 'Sorry, there is a problem with your bank details',
      message: `Please check the details you have entered are correct and try again.
                There can be a slight delay in updating the address where your 
                details are registered. If you believe the rest of the details 
                are correct, please try using the previous address where your 
                bank account was registered.`
    });
    this.messageForAgent = error.errorMsg ? error.errorMsg : ' ';
  }
  static get name() {
    return 'ResidentialNonSupplyAddress422Error';
  }
}

export class ComercialBankAccount422Error extends DefaultError<BankAccountValidationErrorJson> {
  messageForAgent: string;

  constructor(error: CustomError) {
    super({
      error: new Error(JSON.stringify(error)),
      name: ComercialBankAccount422Error.name,
      title: 'Sorry, there is a problem with your company details',
      message: `Please check the details you have entered are correct and try 
                again. This includes the company name and company registration 
                number.`
    });
    this.messageForAgent = error.errorMsg ? error.errorMsg : ' ';
  }
  static get name() {
    return 'ComercialBankAccount422Error';
  }
}

export class ComercialBankAccount412Error extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: ComercialBankAccount412Error.name,
      title: 'Error',
      message: ''
    });
  }
  static get name() {
    return 'ComercialBankAccount412Error';
  }
}

export class BankAccountMaxAttempts422Error extends DefaultError {
  constructor(error?: Error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: BankAccountMaxAttempts422Error.name,
      title: `We're unable to set up your Direct Debit due to your bank details 
              being incorrect.`,
      message: ''
    });
  }
  static get name() {
    return 'BankAccountMaxAttempts422Error';
  }
}

export class BankAccountValidationAPIError extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: BankAccountValidationAPIError.name,
      title: error?.title,
      message: error?.detail || error?.message || 'Unexpected error'
    });
  }
  static get name() {
    return 'BankAccountValidationAPIError';
  }
}
